import GlobalHelper from '../../../Common/Helpers/GlobalHelper';
import SolicitudManager from '../../../Common/Managers/SolicitudManager';
import ClienteManager from '../../../Common/Managers/ClienteManager';
import EstadoManager from '../../../Common/Managers/EstadoManager';

//Import del reducer de DistribucionLimites.
import distribucionLimitesReducer from '../../../store/Reducers/DistribucionLimites';
//Import del reducer de ConfirmadorSolicitud.
import confirmadorSolicitudReducer from '../../../store/Reducers/ConfirmadorSolicitud';
//Import del reducer de PanelSeleccion.
import panelSeleccion from '../../../store/Reducers/PanelSeleccion';

import SeleccionCuentas from '../../../store/Reducers/SeleccionCuentas';

//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { objeto } from '../../NuevaSolicitudCuenta/components/ObjetoFer';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _state = {
    loading: false,
    modalVisible: false,
    routingState: undefined,
    client: { description: "" },
    administrators: [],
    enterprises: [],
    empresasNoModificadas: [],
    cuentasNoModificadas: [],
    administratorSelected: undefined,
    GET_DATOS_CLIENTE_BY_ID: [],
    GET_SOLICITUD_EN_CURSO_BY_CLIENTE: [],
    functions: undefined,
    esPersonaFisica: undefined,
    informacionBorrador: undefined
};

let _cliente = undefined;
let userFeatures = [];

// ACTION TYPES
export const GET_CLIENT_DATA_RESULT = 'GET_CLIENT_DATA_RESULT';
export const GET_CLIENT_DATA = 'GET_CLIENT_DATA';
export const ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE = 'ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE';
export const RESET_ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE = 'RESET_ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE';
export const SELECT_TAB = 'SELECT_TAB';
export const OPEN_MODAL_INFOCLIENTE = 'OPEN_MODAL_INFOCLIENTE';
export const CLOSE_MODAL_INFOCLIENTE = 'CLOSE_MODAL_INFOCLIENTE';
export const OPEN_MODAL_CONFIRMADOR = 'OPEN_MODAL_CONFIRMADOR';
export const SET_USER_FUNCTIONS = 'SET_USER_FUNCTIONS';
export const OBTIENE_LIMITE = 'OBTIENE_LIMITE';
export const RELOAD_VISTA_CLIENTE = 'RELOAD_VISTA_CLIENTE';
export const OPEN_MODAL_DISTRIBUIRLIMITES = 'OPEN_MODAL_DISTRIBUIRLIMITES';
export const CLOSE_MODAL_DISTRIBUIRLIMITES = 'CLOSE_MODAL_DISTRIBUIRLIMITES';
export const ACTUALIZAR_ESTADO_GLOBAL_VISTA_CLIENTE = 'ACTUALIZAR_ESTADO_GLOBAL_VISTA_CLIENTE';
export const ACTUALIZAR_ESTADO_GLOBAL_DATOS_SOLICITUD_VISTA_CLIENTE = 'ACTUALIZAR_ESTADO_GLOBAL_DATOS_SOLICITUD_VISTA_CLIENTE';
export const RESET_STATE_VISTA_CLIENTE = 'RESET_STATE_VISTA_CLIENTE';
export const ACTUALIZAR_LIMITES_VISTA_CLIENTE = 'ACTUALIZAR_LIMITES_VISTA_CLIENTE';
export const SET_STATE_FROM_VIGENTE = 'SET_STATE_FROM_VIGENTE';
export const SET_BORRADOR_ID = 'SET_BORRADOR_ID';
export const SET_EDICION_SOLICITUD_ID = 'SET_EDICION_SOLICITUD_ID';
export const OPEN_PANEL_SELECCION = 'OPEN_PANEL_SELECCION';
export const ACTUALIZAR_DATOS_INICIO_NUEVA_SOLICITUD = 'ACTUALIZAR_DATOS_INICIO_NUEVA_SOLICITUD';
export const CLOSE_MODAL_MSG_CONFIRMADOR = 'CLOSE_MODAL_MSG_CONFIRMADOR';
export const ROUTE_TO_NUEVA_SOLICITUD_CUENTA_VISTA_CLIENTE = 'ROUTE_TO_NUEVA_SOLICITUD_CUENTA_VISTA_CLIENTE';
export const RESET_NUEVA_SOLICITUD_CUENTA_VISTA_CLIENTE = 'RESET_NUEVA_SOLICITUD_CUENTA_VISTA_CLIENTE';
export const CAMBIAR_ESTADO_SOLICITUD = 'CAMBIAR_ESTADO_SOLICITUD';
export const NUEVA_SOLICITUD_ADICIONAL_CUENTA_EXISTENTE = 'NUEVA_SOLICITUD_ADICIONAL_CUENTA_EXISTENTE';
export const ADICIONAL_CUENTA_EXISTENTE = 'ADICIONAL_CUENTA_EXISTENTE';
export const GET_EMPRESAS = 'GET_EMPRESAS';
export const ROUTE_TO_EMPRESA = 'ROUTE_TO_EMPRESA';
export const ROUTE_TO_CUENTA_CLIENTE = 'ROUTE_TO_CUENTA_CLIENTE';
export const SELECCIONAR_COMPONENTE = 'SELECCIONAR_COMPONENTE';
export const DAR_DE_BAJA_CUENTA = 'DAR_DE_BAJA_CUENTA';
export const REDIRECT_TO_AVISO_VIAJE = 'REDIRECT_TO_AVISO_VIAJE';

let _dispatch, _tarjetas = null;

/**
 * Action que obtiene el estado inicial con el cliente recibido por routeState.
 * @param {any} cliente
 * @param {any} currentScope
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch, getState) => {
        const state = getState();

        if (state.tarjetas !== undefined) {
            _tarjetas = JSON.parse(JSON.stringify(state.tarjetas));

            const cliente = state.tarjetas.clienteResultadoBusqueda;

            _cliente = cliente;

            _dispatch = dispatch;
            dispatch({ type: GET_CLIENT_DATA, cliente });

            dispatch({ type: RESET_ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE });

            const reducers = [];
            reducers.push(SeleccionCuentas);
            dispatch({ type: 'STORE_INJECT', reducers: reducers });

            var currentScopeRequest = {
                "UserId": currentScope.UserId,
                "ProductCode": currentScope.ProductCode,
                "ProgramCode": currentScope.ProgramCode
            }

            ConciergeProxy.Execute((data) => _loadClientViewFunctions(data), null, "GETFUNCTIONS", currentScopeRequest);
        }
    }
}

/**
 * Selección de tab de administradoras
 * @param {any} id
 */
export function selectTab(id) {
    LogHelper.In(selectTab.name, id);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SELECT_TAB, selectedId: id });
    }
}

/**
 * Abre el modal de información de cliente.
 */
export function openModalInfoCliente() {
    LogHelper.In(openModalInfoCliente.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: OPEN_MODAL_INFOCLIENTE });
    }
}

/**
 * Cierra el modal de información de cliente.
 */
export function closeModalInfoCliente() {
    LogHelper.In(closeModalInfoCliente.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: CLOSE_MODAL_INFOCLIENTE });
    }
}

/**
 * Abre el modal del confirmador.
 */
export function openModalConfirmador(solicitudId) {
    LogHelper.In(openModalConfirmador.name);

    return (dispatch) => {
        _dispatch = dispatch;

        //Inyecto el reducer de distribucionLimites.
        const reducers = [];
        reducers.push(confirmadorSolicitudReducer);
        dispatch({ type: 'STORE_INJECT', reducers: reducers });

        dispatch({ type: OPEN_MODAL_CONFIRMADOR, solicitudId: solicitudId });
    }
}

/**
 * Cierra el modal del confirmador.
 */
export function closeModalConfirmador() {
    LogHelper.In(closeModalConfirmador.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: CLOSE_MODAL_CONFIRMADOR });
    }
}

/**
 * Cierra el modal del mensaje del confirmador.
 */
export function closeModalMsgConfirmador() {
    LogHelper.In(closeModalMsgConfirmador.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: CLOSE_MODAL_MSG_CONFIRMADOR });
    }
}


/**
 * Reset del state de la pantalla.
 */
export function resetStateVistaCliente() {
    LogHelper.In(resetStateVistaCliente.name);

    _state = {
        loading: false,
        modalVisible: false,
        routingState: undefined,
        client: { description: "" },
        administrators: [],
        enterprises: [],
        empresasNoModificadas: [],
        cuentasNoModificadas: [],
        administratorSelected: undefined,
        GET_DATOS_CLIENTE_BY_ID: [],
        GET_SOLICITUD_EN_CURSO_BY_CLIENTE: [],
        functions: undefined,
        esPersonaFisica: undefined,
        informacionBorrador: undefined
    };

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_STATE_VISTA_CLIENTE });
        dispatch({ type: RESET_STATE_VISTA_CLIENTE, bool: false });
    }
}

/**
 * Abre el modal de distribuir limites.
 */
export function openModalDistribucionLimites() {
    LogHelper.In(openModalDistribucionLimites.name);

    return (dispatch) => {
        _dispatch = dispatch;

        //Inyecto el reducer de distribucionLimites.
        const reducers = [];
        reducers.push(distribucionLimitesReducer);
        dispatch({ type: 'STORE_INJECT', reducers: reducers });

        dispatch({ type: OPEN_MODAL_DISTRIBUIRLIMITES });
    }
}

/**
 * 
 */
export function openPanelSeleccion(entidadTipo, id) {
    LogHelper.In(openPanelSeleccion.name, entidadTipo, id);

    return (dispatch) => {
        _dispatch = dispatch;

        //Inyecto el reducer de panelSeleccion.
        const reducers = [];
        reducers.push(panelSeleccion);
        dispatch({ type: 'STORE_INJECT', reducers: reducers });

        dispatch({
            type: OPEN_PANEL_SELECCION,
            entidadTipo: entidadTipo,
            idEntidad: id,
            activoPanelSeleccion: true
        });
    }
}

/**
 * Cierra el modal de distribuir limites.
 */
export function closeModalDistribucionLimites() {
    LogHelper.In(closeModalDistribucionLimites.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: CLOSE_MODAL_DISTRIBUIRLIMITES });
    }
}

/**
 * Actualiza los limites de la pantalla.
 * @param {any} estado
 */
export function actualizarLimites(estado) {
    LogHelper.In(actualizarLimites.actualizarLimites, estado);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: ACTUALIZAR_LIMITES_VISTA_CLIENTE,
            estado: estado
        });
    }
}

/**REDIRECT A NUEVA SOLICITUD CUENTA PARA MODIFICAR UNA SOLICITUD TIPO 2*/

export function redirectToNuevaSolicitudCuenta() {
    LogHelper.In(redirectToNuevaSolicitudCuenta.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({
            type: ROUTE_TO_NUEVA_SOLICITUD_CUENTA_VISTA_CLIENTE
        });
    }
}

/**REDIRECT A EMPRESA PARA MODIFICAR UNA SOLICITUD TIPO 1 */

export function redirectToEmpresa() {
    LogHelper.In(redirectToNuevaSolicitudCuenta.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({
            type: ROUTE_TO_EMPRESA
        });
    }
}

/**RESETEA NUEVA SOLICITUD CUENTA EN TARJETAS */

export function resetNuevaSolicitudCuenta() {
    LogHelper.In(resetNuevaSolicitudCuenta.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({
            type: RESET_NUEVA_SOLICITUD_CUENTA_VISTA_CLIENTE
        });
    }
}


/**CAMBIA ESTADO DE SOLICITUD EN DB */

/**
 * 
 * @param {*} IdSolicitud 
 * @param {*} nuevoEstadoId 
 */

export function cambiarEstadoSolicitud(IdSolicitud, nuevoEstadoId) {
    LogHelper.In(cambiarEstadoSolicitud.name, IdSolicitud, nuevoEstadoId);

    return (dispatch, getState) => {

        let state = getState();
        let _executionContext = state.sesion.executionContext;
        let callBack;

        callBack = () => {
            dispatch({
                //dispatchea la acción que refleja los cambios en la tabla//
                type: CAMBIAR_ESTADO_SOLICITUD, idNuevoEstado: nuevoEstadoId, IdSolicitud: IdSolicitud
            })
        }

        EstadoManager.CambiarEstadoSolicitud(IdSolicitud, _executionContext, nuevoEstadoId, callBack);

    }
}


/**NUEVA SOLICITUD DE ADICIONAL PARA UNA CUENTA EXISTENTE */
//DEBE TRAER DE BASE DE DATOS TODA LA INFORMACIÓN NECESARIA PARA QUE LA PANTALLA NUEVASOLICITUDADICIONAL FUNCIONE COMO SI SE ESTUVIERA LLAMANDO DESDE NUEVASOLICITUDCUENTA
/**
 * 
 * @param {*} infoCuenta 
 */

export function nuevaSolicitudAdicional(infoCuenta) {
    LogHelper.In(nuevaSolicitudAdicional.name, infoCuenta);


    return (dispatch, getState) => {


        let param = {
            'PRODUCTO_ID': infoCuenta.ProductoId,
            'ADMINISTRADORA_ID': infoCuenta.marcaId,
            'EMPRESA_ID': infoCuenta.empresaId,
            'CLIENTE_ID': infoCuenta.ClienteId,
            'CUENTA_TIPO_ID': infoCuenta.tipoCuentaEmpresaId
        };

        let paramSol = {
            'SOLICITUD_ID': infoCuenta.SolicitudId
        };

        if (infoCuenta.marcaId == 1) {
            LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_CARTERAS_EMPRESA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_CARTERAS_EMPRESA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

            LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_CODIGO_DISTRIBUCION', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_CODIGO_DISTRIBUCION', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

            LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_SUCURSAL_CLIENTE_CUENTA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_SUCURSAL_CLIENTE_CUENTA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

            LogHelper.Out(nuevaSolicitudAdicional.name, paramSol, 'GET_MODIFICACION_SOLICITUD_CUENTA_VISA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
            Engine1Proxy.AddDataSourcesRequests(paramSol, 'GET_MODIFICACION_SOLICITUD_CUENTA_VISA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

            LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_PRODUCTO_VISA_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_PRODUCTO_VISA_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

        } else if (infoCuenta.marcaId == 2) {
            LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_SUCURSAL_CLIENTE_CUENTA_CABAL', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_SUCURSAL_CLIENTE_CUENTA_CABAL', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

            LogHelper.Out(nuevaSolicitudAdicional.name, paramSol, 'GET_MODIFICACION_SOLICITUD_CUENTA_CABAL', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
            Engine1Proxy.AddDataSourcesRequests(paramSol, 'GET_MODIFICACION_SOLICITUD_CUENTA_CABAL', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

            LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_PRODUCTO_CABAL_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_PRODUCTO_CABAL_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

        }
        LogHelper.Out(nuevaSolicitudAdicional.name, null, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_DISTRIBUCION_LIMITES', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_DISTRIBUCION_LIMITES', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

        LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_ATLAS_PARAMETRO_GENERAL', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_PARAMETRO_GENERAL', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

        LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_HABILITACION_CAJERO_PRISMA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_HABILITACION_CAJERO_PRISMA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

        LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_ATLAS_MONEDA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_MONEDA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

        LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_ATLAS_LIMITE_COMPRA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_LIMITE_COMPRA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

        LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        LogHelper.Out(nuevaSolicitudAdicional.name, null, 'GET_SOLICITUD_CUENTA_CABAL_2', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_SOLICITUD_CUENTA_CABAL_2', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

        LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_ATLAS_ENTIDAD_BANCARIA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_ENTIDAD_BANCARIA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

        LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

        LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_TARJETA_TIPO_BY_CUENTA_TIPO', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_TARJETA_TIPO_BY_CUENTA_TIPO', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);

        LogHelper.Out(nuevaSolicitudAdicional.name, param, 'GET_ATLAS_TIPO_CUENTA_BANCARIA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_TIPO_CUENTA_BANCARIA', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);


        Engine1Proxy.Execute((data) => _nuevaSolicitudAdicionalCallback(data, infoCuenta.ProductoId, infoCuenta.marcaId, infoCuenta.tipoCuentaEmpresaId, infoCuenta, dispatch), null, null, "SOLICITUD");

    }
}

export function darDeBajaCuenta(cuenta){
    LogHelper.In(darDeBajaCuenta.name, cuenta);
    
    return (dispatch,getState)=>{
        dispatch({type: DAR_DE_BAJA_CUENTA, cuentaTarjetaId: cuenta.CuentaTarjetaId})
        dispatch({ type: SELECCIONAR_COMPONENTE, componenteId:1 });
        dispatch({ type: ROUTE_TO_CUENTA_CLIENTE,bool:true,cuenta:cuenta });
    }
}



/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

function _nuevaSolicitudAdicionalCallback(data, productoId, administradora, cuentaTipo, infoCuenta, dispatch) {

    let result
    switch (administradora) {
        case 1: {

            result = {
                'cuenta': infoCuenta,
                'empresa': infoCuenta.empresa,
                'GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID': JSON.parse(data.GET_DISTRIBUCION_LIMITES).Recordset0.Rows,
                'GET_PRODUCTO_VISA_PRODUCTO_ID': JSON.parse(data.GET_PRODUCTO_VISA_PRODUCTO_ID).Recordset0.Rows,
                'GET_ATLAS_PARAMETRO_GENERAL': JSON.parse(data.GET_ATLAS_PARAMETRO_GENERAL).Recordset0.Rows,
                'GET_CARTERAS_EMPRESA': JSON.parse(data.GET_CARTERAS_EMPRESA).Recordset0.Rows,
                'GET_SUCURSAL_CLIENTE_CUENTA': JSON.parse(data.GET_SUCURSAL_CLIENTE_CUENTA).Recordset0.Rows,
                'GET_HABILITACION_CAJERO_PRODUCTO': JSON.parse(data.GET_HABILITACION_CAJERO_PRISMA).Recordset0.Rows,
                'GET_ATLAS_MONEDA': JSON.parse(data.GET_ATLAS_MONEDA).Recordset0.Rows,
                'GET_ATLAS_LIMITE_COMPRA': JSON.parse(data.GET_ATLAS_LIMITE_COMPRA).Recordset0.Rows,
                'GET_CODIGO_DISTRIBUCION': JSON.parse(data.GET_CODIGO_DISTRIBUCION).Recordset0.Rows,
                'productoId': productoId,
                'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA': JSON.parse(data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA).Recordset0.Rows.filter(c => c.Id == cuentaTipo),
                'GET_ADMINISTRADORA': JSON.parse(data.GET_ADMINISTRADORA).Recordset0.Rows.filter(c => c.Id == administradora),
                'datosSolicitud': JSON.parse(data.GET_MODIFICACION_SOLICITUD_CUENTA_VISA).Recordset0.Rows,
                'ATLAS_TIPO_COMUNICACION': JSON.parse(data.GET_SOLICITUD_CUENTA_CABAL_2).Recordset0.Rows,
                'GET_ATLAS_ENTIDAD_BANCARIA': JSON.parse(data.GET_ATLAS_ENTIDAD_BANCARIA).Recordset0.Rows,
                'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID': JSON.parse(data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID).Recordset0.Rows,
                'GET_TARJETA_TIPO_BY_CUENTA_TIPO': JSON.parse(data.GET_TARJETA_TIPO_BY_CUENTA_TIPO).Recordset0.Rows,
                'GET_ATLAS_TIPO_CUENTA_BANCARIA': JSON.parse(data.GET_ATLAS_TIPO_CUENTA_BANCARIA).Recordset0.Rows
            }


            break
        }
        case 2: {

            result = {
                'cuenta': infoCuenta,
                //'GET_LIMITE_COMPRA_PRODUCTO': JSON.parse(data.GET_LIMITE_COMPRA_PRODUCTO).Recordset0.Rows,
                //'GET_LINEA_PRESTAMO_PRODUCTO': JSON.parse(data.GET_LINEA_PRESTAMO_PRODUCTO).Recordset0.Rows,
                'GET_ATLAS_PARAMETRO_GENERAL': JSON.parse(data.GET_ATLAS_PARAMETRO_GENERAL).Recordset0.Rows,
                //'GET_CARTERAS_PRODUCTO': JSON.parse(data.GET_CARTERAS_PRODUCTO).Recordset0.Rows,
                //'GET_MODELO_LIQUIDACION_PRODUCTO': JSON.parse(data.GET_MODELO_LIQUIDACION_PRODUCTO).Recordset0.Rows,
                //'GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO': JSON.parse(data.GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO).Recordset0.Rows,
                'GET_SUCURSAL_CLIENTE_CUENTA': JSON.parse(data.GET_SUCURSAL_CLIENTE_CUENTA_CABAL).Recordset0.Rows,
                'GET_HABILITACION_CAJERO_PRODUCTO': JSON.parse(data.GET_HABILITACION_CAJERO_PRISMA).Recordset0.Rows,
                'GET_ATLAS_MONEDA': JSON.parse(data.GET_ATLAS_MONEDA).Recordset0.Rows,
                'GET_ATLAS_LIMITE_COMPRA': JSON.parse(data.GET_ATLAS_LIMITE_COMPRA).Recordset0.Rows,
                //'ATLAS_GRUPO_AFINIDAD': JSON.parse(data.GET_GRUPOS_AFINIDAD_BY_PRODUCTO).Recordset0.Rows,
                'productoId': productoId,
                'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA': JSON.parse(data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA).Recordset0.Rows.filter(c => c.Id == cuentaTipo),
                'GET_ADMINISTRADORA': JSON.parse(data.GET_ADMINISTRADORA).Recordset0.Rows.filter(c => c.Id == administradora),
                'datosSolicitud': JSON.parse(data.GET_MODIFICACION_SOLICITUD_CUENTA_CABAL).Recordset0.Rows,
                'ATLAS_TIPO_COMUNICACION': JSON.parse(data.GET_SOLICITUD_CUENTA_CABAL_2).Recordset0.Rows,
                'GET_ATLAS_ENTIDAD_BANCARIA': JSON.parse(data.GET_ATLAS_ENTIDAD_BANCARIA).Recordset0.Rows,
                'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID': JSON.parse(data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID).Recordset0.Rows,
                'GET_TARJETA_TIPO_BY_CUENTA_TIPO': JSON.parse(data.GET_TARJETA_TIPO_BY_CUENTA_TIPO).Recordset0.Rows,
                'GET_ATLAS_TIPO_CUENTA_BANCARIA': JSON.parse(data.GET_ATLAS_TIPO_CUENTA_BANCARIA).Recordset0.Rows,
                'GET_PRODUCTO_CABAL_PRODUCTO_ID': JSON.parse(data.GET_PRODUCTO_CABAL_PRODUCTO_ID).Recordset0.Rows,
            }
            break

        }
    }
    result.SolicitudId = infoCuenta.SolicitudAdcionalId


    //action que va a poner el true el flag que va a generar el redirect a la pantalla "NuevaSolicitudAdicional"
    dispatch({
        type: NUEVA_SOLICITUD_ADICIONAL_CUENTA_EXISTENTE
    });
    //action que va a pasarle a tarjetas toda la info de la cuenta y parametría
    dispatch({
        type: ADICIONAL_CUENTA_EXISTENTE,
        result
    });


}


function setStateFromVigenteCallback(data, requestId, borradorId, estado, getState) {
    LogHelper.In(setStateFromVigenteCallback.name, data, requestId, borradorId, estado, getState);

    if (borradorId == undefined) {
        SolicitudManager.ReconstruirSolicitudVigente(data, requestId, estado, setEstadoSolicitud, getState, (resultado) => {
            _dispatch({
                type: ACTUALIZAR_ESTADO_GLOBAL_DATOS_SOLICITUD_VISTA_CLIENTE,
                resultado: resultado
            });
        });
    } else {
        let result = JSON.parse(data.ESTADO_BORRADOR);
        result.borradorId = borradorId;
        setEstadoSolicitud(result, estado);
    }
}

function _obtenerDatosParaSolicitud(data) {
    LogHelper.In(_obtenerDatosParaSolicitud.name, data);

    let tarjetasVisa = JSON.parse(data.GET_CUENTA_TARJETA_VISA_BY_CUIT).Recordset1.Rows;
    let cuentasTarjetasVisa = JSON.parse(data.GET_CUENTA_TARJETA_VISA_BY_CUIT).Recordset0.Rows;

    /* let tarjetas = JSON.parse(data.GET_CUENTA_TARJETA_BY_CUIT).Recordset1.Rows.map((tc) => {
         return Object.assign({}, tc, tarjetasVisa.find((tcv) => tcv.TarjetaCreditoId == tc.Id));
     });
 
     let cuentas = JSON.parse(data.GET_CUENTA_TARJETA_BY_CUIT).Recordset0.Rows.map((ct) => {
         ct.CantTarjetasCredito = tarjetas.filter((te) => te.CuentaTarjetaId == ct.Id).length;
         return Object.assign({}, ct, cuentasTarjetasVisa.find((ctv) => ctv.CuentaTarjetaId == ct.Id));
     });*/

    let resultado = {
        'id': 0,
        /*'empresas': JSON.parse(data.GET_EMPRESA_CUIT).Recordset0.Rows,
        'cuentas': cuentas,
        'tarjetas': tarjetas,*/
        'novedadesEmpresas': JSON.parse(data.GET_NOVEDADES_EMPRESA_BY_CUIT).Recordset0.Rows,
        'novedadesCuentas': JSON.parse(data.GET_NOVEDADES_CUENTA_TARJETA_BY_CUIT).Recordset0.Rows,
        'novedadesTarjetas': JSON.parse(data.GET_NOVEDADES_TARJETA_BY_CUIT).Recordset0.Rows,
        'carteras': JSON.parse(data.GET_CARTERAS).Recordset0.Rows
    }

    _dispatch({
        type: ACTUALIZAR_ESTADO_GLOBAL_DATOS_SOLICITUD_VISTA_CLIENTE,
        resultado: resultado
    });

    _dispatch({
        type: ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE
    });
}

function setEstadoSolicitud(data, estado) {
    LogHelper.In(setEstadoSolicitud.name, data, estado);

    data.estadoSolicitud = estado;
    data.esModificacion = true;
    ClienteManager.ActualizarStateVistaCliente(data, _dispatch);
    _dispatch({ type: SET_STATE_FROM_VIGENTE, data: data });
    _dispatch({ type: ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE });
}

/**
 * Carga las funciones de seguridad y de tener la función Consulta carga los datos del cliente
 * @param {any} data
 */
function _loadClientViewFunctions(data) {
    LogHelper.In(_loadClientViewFunctions.name, data);

    userFeatures = JSON.parse(JSON.stringify(data));


    let consultaSociosFunctions = data.CONSULTASOCIOS ? JSON.parse(JSON.stringify(data.CONSULTASOCIOS)) : [];
    let consultaSociosFunctionsAllowed = [];
    let deliveryFunctions = undefined;
    let deliveryFunctionsAllowed = [];
    let solicitudFunctions = undefined;
    let solicitudFunctionsAllowed = [];


    consultaSociosFunctions.forEach(p => { consultaSociosFunctionsAllowed[p.Codigo_Funcion] = true; });
    /*Se valida que el usuario tenga los permisos de delivery*/
    if (data.DELIVERY) {
        deliveryFunctions = JSON.parse(JSON.stringify(data.DELIVERY));
        deliveryFunctions.forEach(p => { deliveryFunctionsAllowed[p.Codigo_Funcion] = true; });
    }
    /*Se valida que el usuario tenga los permisos de solicitudes*/
    if (data.SOLICITUD) {
        solicitudFunctions = JSON.parse(JSON.stringify(data.SOLICITUD));
        solicitudFunctions.forEach(p => { solicitudFunctionsAllowed[p.Codigo_Funcion] = true; });
    }

    _dispatch({
        type: SET_USER_FUNCTIONS,
        consultaSociosFunctionsAllowed,
        solicitudFunctionsAllowed,
        deliveryFunctionsAllowed,
        userFeatures
    });

    /*Si tiene permisos sobre la consulta de la pantalla, hago el resto de las llamadas*/
    if (consultaSociosFunctionsAllowed.Consulta == true) {
        getIdCliente(data);
    }
}

/**
 * BUSCA EL CLIENTE POR CUIT EN BASE DE DATOS PARA OBTENER EL ID SI EXISTE Y CARGAR LAS SOLICITUDES, POR SI SE CARGAN SOLICITUDES PARA UN CLIENTE NUEVO
 * @param {*} data 
 */
function getIdCliente(data) {
    LogHelper.In(getIdCliente.name);

    let param = {
        'NRO_DOC': _cliente.NumeroDocumento
    }

    //  AddDataSourcesRequests: function (localValues, key, requestType, product, category, value, cacheKeyLevel, isQuery, resultId) {


        Engine1Proxy.AddDataSourcesRequests(param, 'GET_CLIENTE_NRODOC', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'clientesObtenidos');
    Engine1Proxy.Execute((datos) => { _loadClientView(datos, data) }, null, null, "CONSULTASOCIOS");


}

/**
 * Arma los DataSourceRequest para traer todos los datos del cliente
 */
function _loadClientView(datos, permisos) {
    LogHelper.In(_loadClientView.name);
    
    let clienteDB = JSON.parse(datos.clientesObtenidos).Recordset0.Rows;
    
    if (clienteDB.length > 0) {
        clienteDB = clienteDB[0]
    } else {
        clienteDB = null
    }

    //Cliente en BD
    if (clienteDB) {
        let param = { 'CLIENTE_ID': clienteDB.Id, 'clienteId': clienteDB.Id }

        //  AddDataSourcesRequests: function (localValues, key, requestType, product, category, value, cacheKeyLevel, isQuery, resultId) {
        //Engine1Proxy.AddDataSourcesRequests(param, 'GET_CLIENTE_NRODOC', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'clientesObtenidos');

        LogHelper.Out(_loadClientView.name, param, 'GET_DATOS_CLIENTE_BY_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_DATOS_CLIENTE_BY_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        LogHelper.Out(_loadClientView.name, param, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'User', true);
        LogHelper.Out(_loadClientView.name, param, 'GET_CLIENTE_BY_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_CLIENTE_BY_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        LogHelper.Out(_loadClientView.name, param, 'GET_CLIENTE_LIMITES_BY_CLIENTEID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_CLIENTE_LIMITES_BY_CLIENTEID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        LogHelper.Out(_loadClientView.name, param, 'GET_SOLICITUDES_BY_ID_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_SOLICITUDES_BY_ID_CLIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        LogHelper.Out(_loadClientView.name, param, 'CONSULTA_SOLICITUD_CUENTA_CUENTAS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'CONSULTA_SOLICITUD_CUENTA_CUENTAS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        LogHelper.Out(_loadClientView.name, param, 'CONSULTA_SOLICITUD_CUENTA_EMPRESA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(param, 'CONSULTA_SOLICITUD_CUENTA_EMPRESA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);

        Engine1Proxy.Execute((data) => {
            _loadClientViewInitialStateData(data, permisos, clienteDB)
        }, null, null, "CONSULTASOCIOS");
    }
    else {
        _loadClientViewInitialStateData(undefined, permisos, clienteDB);
    }
}


function setTarjetas(data, cuentas) {
    LogHelper.In(setTarjetas.name, data, cuentas);

    cuentas.forEach(function (cuenta, i) {
        cuenta.cards = [];
        let tarjetas = JSON.parse(data[i]).Recordset0.Rows;
        cuenta.cards.information = JSON.parse(data[i]).Recordset1.Rows[0];
        tarjetas.forEach(function (tarjeta) {
            cuenta.cards.push(tarjeta);
        });
    });
}

/**
 * Callback de los DataSourceRequest iniciales de carga. 
 * @param {any} data - Data del callback
 * @param {any} clienteWS - Cliente proveniente del WS
 */
function _loadClientViewInitialStateData(data, permisos, clienteDB) {
    LogHelper.In(_loadClientViewInitialStateData.name, data, clienteDB);

    //TODO: Anterior _cliente.TipoDocumento.Codigo, se reemplaza por _cliente.resultadoBD["0"].TipoDocumentoCodigo. VER!
    _cliente.NUMERO_DOCUMENTO_FORMATO = GlobalHelper.ConvertirNumeroDocumento(_cliente.NumeroDocumento, _cliente.TIPO_DOCUMENTO_ID);
    _cliente.limiteFormato = GlobalHelper.ConvertirNumeroConDecimales(_cliente.Limite);
    _cliente.Id = clienteDB ? clienteDB.Id : null;

    //Si el callback viene de BD
    if (_cliente.Id > 0 || (clienteDB && clienteDB.Id > 0)) {
        //Arma el array de empresas
        let enterprises = [];
          

        //Armo el estado global
        _state.client = _cliente;
        _state.enterprises = enterprises;
        //_state.administrators = JSON.parse(data.GET_ADMINISTRADORA_IN_SOLICITUD_CUENTA_TARJETA_BY_CLIENTE).Recordset0.Rows;
        _state.GET_DATOS_CLIENTE_BY_ID = JSON.parse(data.GET_DATOS_CLIENTE_BY_ID).Recordset0.Rows;
        _state.GET_CLIENTE_BY_ID = JSON.parse(data.GET_CLIENTE_BY_ID).Recordset0.Rows;
        _state.GET_ADMINISTRADORA = JSON.parse(data.GET_ADMINISTRADORA).Recordset0.Rows;
        _state.CONSULTA_SOLICITUD_CUENTA_CLIENTE = JSON.parse(data.GET_CLIENTE_LIMITES_BY_CLIENTEID).Recordset0.Rows;
        _state.GET_SOLICITUDES_BY_ID_CLIENTE = JSON.parse(data.GET_SOLICITUDES_BY_ID_CLIENTE).Recordset0.Rows;
        //_state.CONSULTA_SOLICITUDES_CUENTA_CABAL = JSON.parse(data.CONSULTA_SOLICITUDES_CUENTA_CABAL).Recordset0.Rows;
        _state.CONSULTA_TARJETAS = JSON.parse(data.GET_SOLICITUDES_BY_ID_CLIENTE).Recordset1.Rows;
        _state.CONSULTA_TARJETAS_CABAL = JSON.parse(data.GET_SOLICITUDES_BY_ID_CLIENTE).Recordset2.Rows;
        _state.CONSULTA_TARJETAS_MASTER = JSON.parse(data.GET_SOLICITUDES_BY_ID_CLIENTE).Recordset3.Rows;
        _state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_VISA = JSON.parse(data.CONSULTA_SOLICITUD_CUENTA_CUENTAS).Recordset0.Rows;
        _state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_OTRAS = JSON.parse(data.CONSULTA_SOLICITUD_CUENTA_CUENTAS).Recordset0.Rows;
        _state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES = JSON.parse(data.CONSULTA_SOLICITUD_CUENTA_CUENTAS).Recordset1.Rows;
        _state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES_CABAL = JSON.parse(data.CONSULTA_SOLICITUD_CUENTA_CUENTAS).Recordset1.Rows;
        _state.CONSULTA_SOLICITUD_CUENTA_EMPRESA = JSON.parse(data.CONSULTA_SOLICITUD_CUENTA_EMPRESA).Recordset0.Rows;
        //_state.GET_SOLICITUD_EN_CURSO_BY_CLIENTE = JSON.parse(data.GET_SOLICITUD_EN_CURSO_BY_CLIENTE).Recordset0.Rows;
        _state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_VISA = _state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_VISA.filter(cuenta=>cuenta.marcaId==1);
        _state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES = _state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES.filter(integ=>integ.administradoraId == 1)        
        if (_cliente.Id) {
            if (_cliente.esPersonaFisica) {
                _state.client.tipoCliente = "Persona Física";
            }
            else {
                _state.client.tipoCliente = "Persona Jurídica";
            }
        } else {
            if (clienteDB.FisicaJuridica == "F") {
                _state.client.tipoCliente = "Persona Física";
            }
            else {
                _state.client.tipoCliente = "Persona Jurídica";
            }
        }
        
        //Armo DataSourceRequests para buscar datos por CUIT
        let parameter;
        let localvalue;

        if (_state.client && _state.client.Cuit && _state.client.Cuit.toString().indexOf('-') > -1) {
            //Se cambia "_state.client.Cuit por _state.GET_CLIENTE_BY_ID[0].Cuit"
            parameter = { 'CUIT': parseInt(_state.client.Cuit.split('-').join('')) }
            localvalue = { "BANCO_CLIENTE_ID": parseInt(_state.client.Cuit.split('-').join('')) };
        } else {
            parameter = { 'CUIT': parseInt(_state.client.Cuit) }
            localvalue = { "BANCO_CLIENTE_ID": parseInt(_state.client.Cuit) };
        }
        
        //-
        //- SE COMENTA ESTA PARTE DE CÓDIGO YA QUE NO SE UTILIZA PARA EL TENANT DE UALA.
        //-
        /*solamente si el usuario tiene permisos de alta en la solicitud*/
       /* if (permisos.SOLICITUD.some(cs => cs.Codigo_Funcion == "Alta")) {
            LogHelper.Out(_loadClientViewInitialStateData.name, localvalue, 'INFORMACION_BORRADOR', 'Get', 'Tarjetas', 'SOLICITUD', null, 'Product', true);
            Engine1Proxy.AddDataSourcesRequests(localvalue, 'INFORMACION_BORRADOR', 'Get', 'Tarjetas', 'SOLICITUD', null, 'Product', true);
            Engine1Proxy.Execute((data) => _loadEnterpriseData(data, _state), null, null, "CONSULTASOCIOS");
        } else {           
        }*/

        _loadEnterpriseData(data, _state);
    } else {
        //Si el callback viene del WS de clientes
        //Si el cliente viene undefined, seteo estado con datos cliente default
        
        let nombreYapellido;
        if (_cliente.apellido != undefined) {
            nombreYapellido = _cliente.nombre + " " + _cliente.apellido;
        }
        else {
            nombreYapellido = _cliente.nombre;
        }

        //Seteo datos del cliente
        _state.client = _cliente;

        if (_cliente.esPersonaFisica) {
            _state.client.tipoCliente = "Persona Física";
        }
        else {
            _state.client.tipoCliente = "Persona Jurídica";
        }
        //_state.client.tipoDocumentoId = _cliente.TipoDocumento != undefined ? _cliente.TipoDocumento.Id : undefined;
        //_state.client.tipoIva = _cliente.TipoIva != undefined ? _cliente.TipoDocumento.Descripcion : undefined;

        //Armo DataSourceRequests para buscar datos por CUIT
        let localvalue = { "BANCO_CLIENTE_ID": _state.client.Cuit };

        LogHelper.Out(_loadClientViewInitialStateData.name, localvalue, 'INFORMACION_BORRADOR', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(localvalue, 'INFORMACION_BORRADOR', 'Get', 'Tarjetas', 'SOLICITUD', null, 'User', true);
        LogHelper.Out(_loadClientViewInitialStateData.name, null, 'GET_NOVEDADES_CAMPO_LIMITES', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_NOVEDADES_CAMPO_LIMITES', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', null, 'User', true);
        
        Engine1Proxy.Execute((data) => _loadParam(data, _state), null, null, "CONSULTASOCIOS");
    }
}

/**
 * Callback de datos buscados por CUIT en cliente traído por BD GYF
 * @param {any} data - Data proveniente de los request
 * @param {any} state - Estado general
 */
function _loadEnterpriseData(data, state) {
    LogHelper.In(_loadEnterpriseData.name, data, state);

    //OBTENGO DATOS DEL BORRADOR.
    _state.informacionBorrador = null;

    if (data.hasOwnProperty("INFORMACION_BORRADOR")) {
        _state.informacionBorrador = JSON.parse(data.INFORMACION_BORRADOR);
    }

    //let novedadesCampoLimites = JSON.parse(data.GET_NOVEDADES_CAMPO_LIMITES).Recordset0.Rows;

    if (_state.informacionBorrador != undefined) {
        _state.informacionBorrador.forEach(function (item) {
            let borradorItem = {};

            borradorItem.Administradora = item.Administradora;
            borradorItem.AdministradoraAbrev = undefined;
            borradorItem.AdministradoraId = undefined;
            borradorItem.Cuenta = item.Cuenta;
            borradorItem.Empresa = item.Empresa;
            borradorItem.EsConfidencial = undefined;
            borradorItem.Estado = undefined;
            borradorItem.Fecha = undefined;
            borradorItem.Nuevas = item.TarjetasNuevas;
            borradorItem.Numero = 0;
            borradorItem.PantallaActual = undefined;
            borradorItem.Tipo = item.Tipo;
            borradorItem.BorradorId = item.BorradorId;

            _state.GET_SOLICITUD_EN_CURSO_BY_CLIENTE.push(borradorItem);
        });
    }
    if (_state.GET_SOLICITUD_EN_CURSO_BY_CLIENTE != undefined) {
        let index = 0;
        _state.GET_SOLICITUD_EN_CURSO_BY_CLIENTE.forEach(function (item) {
            item.Index = index;
            index += 1;
        });
    }

    //let novedadesEmpresa = JSON.parse(data.GET_NOVEDADES_EMPRESA_BY_CUIT).Recordset0.Rows;
    //let novedadesCuenta = JSON.parse(data.GET_NOVEDADES_CUENTA_TARJETA_BY_CUIT).Recordset0.Rows;
    // let novedadesEmpresaAll = JSON.parse(data.GET_ALL_NOVEDADES_EMPRESA_BY_CUIT).Recordset0.Rows;
    // let novedadesCuentaAll = JSON.parse(data.GET_ALL_NOVEDADES_CUENTA_TARJETA_BY_CUIT).Recordset0.Rows
    // let novedadesTarjetasAll = JSON.parse(data.GET_ALL_NOVEDADES_TARJETA_BY_CUIT).Recordset0.Rows;
    // let equivalenciaAtlasCategoriaIvaCodigoVisa = JSON.parse(data.GET_CATEGORIA_IVA_BY_ID).Recordset0.Rows[0];

    //state.GET_EMPRESA_CUIT = JSON.parse(data.GET_EMPRESA_CUIT).Recordset0.Rows;
    // state.GET_CUENTA_TARJETA_BY_CUIT = JSON.parse(data.GET_CUENTA_TARJETA_BY_CUIT).Recordset0.Rows;
    /* MDIAZ 20190410:
     * La siguiente línea fue comentada dado que la consulta al DS que alimenta el dato que requiere fue comentada
     * también, debido a que los SPs que representan a diferentes DS tienen errores que se corregirán en breve.
     * (ver commit ab6928aa y su comentario).
    state.GET_CUENTA_TARJETA_CON_BAJA_BY_CUIT = JSON.parse(data.GET_CUENTA_TARJETA_CON_BAJA_BY_CUIT).Recordset0.Rows;
    */

    _cliente.TipoIIBB != null ? _state.client.tipoIibbCodigo = _cliente.TipoIIBB.Codigo : _state.client.tipoIibbCodigo = undefined

    //Seteo límites de empresa
    for (var i = 0; i < state.enterprises.length; i++) {
        for (var j = 0; j < novedadesEmpresa.length; j++) {
            if (state.enterprises[i].Id === novedadesEmpresa[j].EmpresaId) {
                state.enterprises[i].limitecompra = novedadesEmpresa[j].ValorNovedad;
                state.enterprises[i].limitecompraFormato = GlobalHelper.ConvertirNumeroMilesMillones(novedadesEmpresa[j].ValorNovedad);
            }
            else {
                state.enterprises[i].limitecompraFormato = GlobalHelper.ConvertirNumeroMilesMillones(state.enterprises[i].limitecompra);
            }
        }

        for (var k = 0; k < state.enterprises[i].accounts.length; k++) {
            for (var l = 0; l < novedadesCuenta.length; l++) {
                state.enterprises[i].accounts[k].ValorFormato = GlobalHelper.ConvertirNumeroMilesMillones(state.enterprises[i].accounts[k].Valor);
                state.enterprises[i].accounts[k].valorAnterior = state.enterprises[i].accounts[k].Valor;
            }
        }
    }

    for (var i = 0; i < state.enterprises.length; i++) {
        state.enterprises[i].cantidadNovedadesEmpresa = 0;
        for (var j = 0; j < novedadesEmpresaAll.length; j++) {
            if (state.enterprises[i].Id === novedadesEmpresaAll[j].EmpresaId) {
                state.enterprises[i].cantidadNovedadesEmpresa++;
            }
        }

        for (var k = 0; k < state.enterprises[i].accounts.length; k++) {
            state.enterprises[i].accounts[k].cantidadNovedadesCuenta = 0;
            for (var l = 0; l < novedadesCuentaAll.length; l++) {
                if (state.enterprises[i].accounts[k].Id === novedadesCuentaAll[l].CuentaTarjetaId) {
                    state.enterprises[i].accounts[k].cantidadNovedadesCuenta++;
                }
            }
            for (var m = 0; m < state.enterprises[i].accounts[k].cards.length; m++) {
                state.enterprises[i].accounts[k].cards[m].cantidadNovedadesTarjetas = 0;
                for (var r = 0; r < novedadesTarjetasAll.length; r++) {
                    if (state.enterprises[i].accounts[k].cards[m].Id === novedadesTarjetasAll[r].TarjetaCreditoId) {
                        state.enterprises[i].accounts[k].cards[m].cantidadNovedadesTarjetas++;
                        state.enterprises[i].accounts[k].cards[m].limiteAnterior = state.enterprises[i].accounts[k].cards[m].PorcentajeLimiteCompra;
                    }
                }
            }
        }
    }

    /*
     * MDIAZ 20190410:
     * Se comenta este código para revisar inconsistencias entre lo que se espera encontrar en el objeto _cliente
     * y lo que realmente hay en el state. Verificar si es un bug o un work-in-progress
    state.client.numeroDocumentoFormato = _cliente.NUMERO_DOCUMENTO_FORMATO;
    state.client.tipoDocumentoCodigo = _cliente.TipoDocumento.Codigo;
    state.client.titulo = _cliente.RazonSocial != undefined ? _cliente.RazonSocial : _cliente.Nombre + " " + _cliente.Apellido
    state.client.tipoIva = equivalenciaAtlasCategoriaIvaCodigoVisa.Descripcion;

    _dispatch({
        type: ACTUALIZAR_ESTADO_GLOBAL_VISTA_CLIENTE, cliente: state.client, novedadesCampoLimites: novedadesCampoLimites, novedades: {
            novedadesEmpresas: novedadesEmpresaAll,
            novedadesCuentas: novedadesCuentaAll,
            novedadesTarjetas: novedadesTarjetasAll
        }
    });
    */

    //SE MAPEAN LAS EMPRESAS Y CUENTAS PARA QUE LOS OBJETOS COINCIDAN CON LO QUE ESPERAN RECIBIR LOS COMPONENTES "NuevaSolicitudEmpresa" y "Empresa"

    let empresas = [];
    let cuentas = [];

    state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_VISA.map(cuenta => {
        cuenta.Id = cuenta.CuentaTarjetaId;
        cuenta.EmpresaId = cuenta.empresaId;
        cuenta.Valor = cuenta.limite;
        cuenta.ProductoId = cuenta.productoId;
        cuenta.Descripcion = cuenta.denominacionCuenta;
        cuenta.ModalidadDistribucionLimiteId = cuenta.modeloDistribucionId;
    })

    state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_OTRAS.map(cuenta => {
        cuenta.Id = cuenta.CuentaTarjetaId;
        cuenta.ProductoId = cuenta.productoId;
        cuenta.Descripcion = cuenta.denominacionCuenta;
        cuenta.Valor = cuenta.limite;
        cuenta.ProductoId = cuenta.productoId;
        cuenta.Descripcion = cuenta.denominacionCuenta;
        cuenta.ModalidadDistribucionLimiteId = cuenta.modeloDistribucionId;
    })

    state.CONSULTA_SOLICITUD_CUENTA_EMPRESA.map(empresa => {
        let empresaAux = empresa;

        empresaAux.LimiteCompra = empresa.limite;
        empresaAux.Denominacion = empresa.empresaDenominacion;
        empresaAux.EmpresaVisaEstadoId = empresa.estado;
        empresaAux.limiteCompraFormato = GlobalHelper.ConvertirNumeroSinDecimales(empresa.limite);
        empresaAux.Id = empresa.empresaId;
        empresaAux.AdministradoraId = empresa.marcaId;
        empresaAux.TipoDeEmpresa = empresa.tipoCuentaDescripcion;

        empresas.push(empresaAux);

    })

    state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES.map(tarjeta => {
        tarjeta.ClienteNombre = tarjeta.Nombre + " " + tarjeta.Apellido;
        tarjeta.administradoraId = 1;
    })

    state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES_CABAL.map(tarjeta => {
        tarjeta.ClienteNombre = tarjeta.Nombre + " " + tarjeta.Apellido;
        tarjeta.administradoraId = 2;
    })

    state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES = state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES.concat(state.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES_CABAL);


    state.empresas = empresas;
    
    _dispatch({ type: GET_CLIENT_DATA_RESULT, data: state });
    //"GET_EMPRESAS" GUARDA EN TARJETAS LAS EMPRESAS, CUENTAS, TARJETAS Y LÍMITES TRAÍDOS POR LOS SP'S PARA SU POSTERIOR CONSUMO EN COMPONENTES "EMPRESA", "NUEVA SOLICITUD EMPRESA" Y "DISTRIBUCIÓN LÍMITES" 
    _dispatch({ type: GET_EMPRESAS, data: state });
}

/**
  * Callback de búsqueda de límites y parámetros para cliente traído por WS
  * @param {any} data - Data proveniente de los request
  * @param {any} state - Estado general
 */
function _loadParam(data, state) {
    LogHelper.In(_loadParam.name, data, state);
  
    //OBTENGO DATOS DEL BORRADOR.
    _state.informacionBorrador = JSON.parse(data.INFORMACION_BORRADOR);

    let novedadesCampoLimites = JSON.parse(data.GET_NOVEDADES_CAMPO_LIMITES).Recordset0.Rows;

    _state.GET_SOLICITUD_EN_CURSO_BY_CLIENTE = [];

    if (_state.informacionBorrador != undefined) {
        _state.informacionBorrador.forEach(function (item) {
            let borradorItem = {};

            borradorItem.Administradora = item.Administradora;
            borradorItem.AdministradoraAbrev = undefined;
            borradorItem.AdministradoraId = undefined;
            borradorItem.Cuenta = item.Cuenta;
            borradorItem.Empresa = item.Empresa;
            borradorItem.EsConfidencial = undefined;
            borradorItem.Estado = undefined;
            borradorItem.Fecha = undefined;
            borradorItem.Nuevas = item.TarjetasNuevas;
            borradorItem.Numero = 0;
            borradorItem.PantallaActual = undefined;
            borradorItem.Tipo = undefined;
            borradorItem.BorradorId = item.BorradorId;

            _state.GET_SOLICITUD_EN_CURSO_BY_CLIENTE.push(borradorItem);
        });
    }
    if (_state.GET_SOLICITUD_EN_CURSO_BY_CLIENTE != undefined) {
        let index = 0;
        _state.GET_SOLICITUD_EN_CURSO_BY_CLIENTE.forEach(function (item) {
            item.Index = index;
            index += 1;
        });
    }

    state.client.tipoDocumentoId = _cliente.TIPO_DOCUMENTO_ID != undefined ? _cliente.TIPO_DOCUMENTO_ID : undefined
    state.client.tipoDocumentoCodigo = _cliente.TIPO_DOCUMENTO != undefined ? _cliente.TIPO_DOCUMENTO : undefined
    state.client.categoriaIvaId = _cliente.tipoIva
    state.client.categoriaIvaCodigo = _cliente.iva
    state.client.tipoIibbId = _cliente.TipoIIBB != undefined ? _cliente.TipoIIBB.Id : undefined
    state.client.tipoIibbCodigo = _cliente.TipoIIBB != undefined ? _cliente.TipoIIBB.Codigo : undefined
    state.client.nacionalidadId = _cliente.Nacionalidad != undefined ? _cliente.Nacionalidad : undefined
    state.client.ocupacionId = _cliente.ocupacionId != undefined ? _cliente.ocupacionId : undefined
    state.client.estadoCivilId = _cliente.estadoCivilId != undefined ? _cliente.estadoCivilId : undefined

    state.client.numeroDocumentoFormato = _cliente.NUMERO_DOCUMENTO_FORMATO;
    state.client.titulo = _cliente.RAZON_SOCIAL && _cliente.RAZON_SOCIAL != "" ? _cliente.RAZON_SOCIAL : _cliente.NOMBRE + " " + _cliente.APELLIDO;

    _dispatch({
        type: ACTUALIZAR_ESTADO_GLOBAL_VISTA_CLIENTE, cliente: state.client, novedadesCampoLimites: novedadesCampoLimites, novedades: {
            novedadesEmpresas: [],
            novedadesCuentas: [],
            novedadesTarjetas: []
        }
    });
    _dispatch({ type: GET_CLIENT_DATA_RESULT, data: state });
}

//ACTION QUE SE EJECUTA DESDE TableRowCuentas.jsx para eliminar una cuenta en casa de estar activado.
export function eliminarCuenta(infoCuenta) {
    LogHelper.In(eliminarCuenta.name, infoCuenta);

    return (dispatch, getState) => {
        console.log("-------------------TODO-----------------")
    };
};

//ACTION QUE SE EJECUTA DESDE TableRowCuentas.jsx para abrir la cuenta seleccionada.
export function AbrirModuloConsultaOperacionCuenta(infoCuenta) {
    LogHelper.In(AbrirModuloConsultaOperacionCuenta.name, infoCuenta);

    return (dispatch, getState) => {
        dispatch({ type: SELECCIONAR_COMPONENTE, componenteId:1 });
        dispatch({ type: ROUTE_TO_CUENTA_CLIENTE,bool:true,cuenta:infoCuenta });
    };
};

export function seleccionarComponente(componenteId,infoCuenta){
    LogHelper.In(seleccionarComponente.name,componenteId);
    
    return (dispatch, getState) => {
        dispatch({ type: SELECCIONAR_COMPONENTE, componenteId });
        dispatch({ type: ROUTE_TO_CUENTA_CLIENTE,bool:true,cuenta:infoCuenta });
    }
}

export function redirectToAvisoViaje(bool) {
    LogHelper.In(redirectToAvisoViaje.name,bool);

    return (dispatch, getState) => {
        dispatch({ type: REDIRECT_TO_AVISO_VIAJE });
    };
};